import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isTeachersEnabled } from 'utils/authScopes';
import ASQHeaderSort from './ASQHeaderSort';

class ASQSurveysHeader extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    onSortChange: PropTypes.func.isRequired,
  }

  onSortChange = (e) => {
    const sort = e.currentTarget.dataset.sort;
    const order = this.props.meta.order || 'asc';
    const newOrder = order === 'desc' ? 'asc' : 'desc';
    this.props.onSortChange(sort, newOrder);
  }

  render() {
    const { t, auth, meta } = this.props;
    return (
      <div className='o-rtable__row'>
        <ASQHeaderSort meta={meta} idx={1} onSortChange={this.onSortChange}>
          <b>{t('asqSurveys.header.studentName')}</b>
        </ASQHeaderSort>
        <ASQHeaderSort meta={meta} idx={2} cls='o-rtable__cell--date' onSortChange={this.onSortChange}>
          <b>{t('asqSurveys.header.dateInvited')}</b>
        </ASQHeaderSort>
        {isTeachersEnabled(auth) && (
          <ASQHeaderSort meta={meta} idx={3} onSortChange={this.onSortChange}>
            <b>{t('asqSurveys.header.mostRecentTeacherAsq')}</b>
          </ASQHeaderSort>
        )}
        <ASQHeaderSort meta={meta} idx={4} onSortChange={this.onSortChange}>
          <b>{t('asqSurveys.header.mostRecentParentAsq')}</b>
        </ASQHeaderSort>
        {meta.followUpEnabled &&
          <ASQHeaderSort meta={meta} idx={5} onSortChange={this.onSortChange}>
            <b>{t('asqSurveys.header.followUp')}</b>
          </ASQHeaderSort>
        }
      </div>
    );
  }
}

export default withTranslation()(ASQSurveysHeader);
